import React from 'react'
import styled from "styled-components";
import { FiCommand } from "react-icons/fi";

export default function Loader(props) {
  return (
    <Container>
        <div id='loader' style={props.loaderCss}><FiCommand className="loading-icon" style={props.iconCss} /></div>
    </Container>
  )
}

const Container = styled.div`
#loader{
    position: absolute;
    color: white;
    z-index: 3;
    .loading-icon {
        animation: animate 2s infinite;
    }

    @keyframes animate {
        0% {
        transform: rotate(0deg);
        }
        100% {
        transform: rotate(720deg);
        }
    }
}
`